export let Logs = {
    path: 'logs',
    name: 'logs',
    meta: {
        roleCode: '009',
    },
    component: () =>
        import ( /* webpackChunkName: "logs-page" */ '@/views/back-stage/logs/logs-page.vue'),
    children: [{
            path: 'integrate',
            name: 'integrate',
            component: () =>
                import (
                    /*webpackChunkName:"integrate-page"*/
                    '@/views/back-stage/logs/integrate-page.vue'
                ),
        },
        {
            path: 'apppush',
            name: 'apppush',
            component: () =>
                import (
                    /*webpackChunkName:"apppush-page"*/
                    '@/views/back-stage/logs/apppush-page.vue'
                ),
        },
        {
            path: 'exception',
            name: 'exception',
            component: () =>
                import (
                    /*webpackChunkName:"exception-page"*/
                    '@/views/back-stage/logs/exception-page.vue'
                ),
        },
        {
            path: 'invorklog',
            name: 'invorklog',
            component: () =>
                import (
                    /*webpackChunkName:"service-invorklog"*/
                    '@/views/back-stage/logs/service-invorklog.vue'
                ),
        },
        {
            path: 'invalidinvorklog',
            name: 'invalidinvorklog',
            component: () =>
                import (
                    /*webpackChunkName:"invalid-invorklog"*/
                    '@/views/back-stage/logs/invalid-invorklog.vue'
                ),
        },
        {
            path: 'Login',
            name: 'Login',
            component: () =>
                import (
                    /*webpackChunkName:"Login"*/
                    '@/views/back-stage/logs/login.vue'
                ),
        },
        {
            path: 'onLineUser',
            name: 'onLineUser',
            component: () =>
                import (
                    /*webpackChunkName:"Login"*/
                    '@/views/back-stage/logs/onLineUser.vue'
                ),
        },
        {
            path: '*',
            redirect: 'invorklog',
        },
    ],
};